import { cn } from "../../utils/helpers";
import Logo from "../Logo/Logo";

interface LoaderProps {
    className?: string;
    wrapperClassName?: string;
    loaderType?: "page" | "inline" | "section";
    dataTestId?: string;
}

export default function Loader({
    className,
    wrapperClassName,
    loaderType = "section",
    dataTestId,
}: LoaderProps) {
    const loaderClass =
        "[border:3px_solid_var(--color-stroke))] ![border-top:3px_solid_var(--loader-color)] rounded-[50%] loader_animation";

    if (loaderType === "page") {
        return (
            <div
                className={cn(
                    "bg-transparent h-dvh w-full flex items-center justify-center",
                    wrapperClassName
                )}
                data-testid={dataTestId}
            >
                <div className="gap-x-2 flex items-center">
                    <Logo />
                    <span
                        className={cn(`${loaderClass} size-[50px]`, className)}
                    />
                </div>
            </div>
        );
    }

    if (loaderType === "section") {
        return (
            <div
                className={cn(
                    "h-[200px] w-full bg-transparent flex items-center justify-center",
                    wrapperClassName
                )}
                data-testid={dataTestId}
            >
                <span
                    className={cn(
                        `${loaderClass} size-[32px] ![border-width:2.5px]`,
                        className
                    )}
                />
            </div>
        );
    }

    return (
        <span
            className={cn(
                `${loaderClass} size-[16px] inline-flex ![border-width:2.5px]`,
                className
            )}
            data-testid={dataTestId}
        />
    );
}
